import createMappedRegion from '../createMappedRegion';
function createRegion(initialValue, option) {
    let region;
    if (initialValue !== undefined) {
        region = createMappedRegion(initialValue, option);
    }
    else {
        region = createMappedRegion(undefined, option);
    }
    const set = (resultOrFunc) => {
        return region.set('value', resultOrFunc);
    };
    const reset = () => {
        return region.reset('value');
    };
    const load = promise => {
        return region.load('value', promise);
    };
    const loadBy = (asyncFunction, reducer) => {
        return region.loadBy('value', asyncFunction, reducer);
    };
    const getValue = () => {
        return region.getValue('value');
    };
    const getLoading = () => {
        return region.getLoading('value');
    };
    const getError = () => {
        return region.getError('value');
    };
    const useValue = (selector) => {
        return region.useValue('value', selector);
    };
    const useLoading = () => {
        return region.useLoading('value');
    };
    const useError = () => {
        return region.useError('value');
    };
    return {
        set,
        reset,
        load,
        loadBy,
        getValue,
        getLoading,
        getError,
        useValue,
        useLoading,
        useError,
    };
}
export default createRegion;
